import React, { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';

const TerminSelector = ({ onTerminChange }) => {
  const [terminer, setTerminer] = useState([]);
  const [selectedId, setSelectedId] = useState('');

  useEffect(() => {
    const fetchTerminer = async () => {
      try {
        const res = await apiClient.get('/api/terminer');
        const allTermins = res.data;
        setTerminer(allTermins);

        // Find standard termin (samme logik som ClassManagementPage)
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth(); 
        const isSecondHalf = currentMonth >= 6; 
        const seasonSearch = isSecondHalf ? 'Vinter' : 'Sommer'; 
        
        let defaultTerm = allTermins.find(t => 
          t.navn.includes(currentYear.toString()) && 
          (t.navn.includes(seasonSearch) || (seasonSearch === 'Sommer' && t.navn.includes('Forår')))
        );

        if (!defaultTerm && allTermins.length > 0) defaultTerm = allTermins[0];

        if (defaultTerm) {
          setSelectedId(defaultTerm.id);
          onTerminChange(defaultTerm.id); // Giv besked til forældre-komponenten med det samme
        }
      } catch (err) { console.error(err); }
    };

    fetchTerminer();
  }, []);

  const handleChange = (e) => {
    const newVal = e.target.value;
    setSelectedId(newVal);
    onTerminChange(newVal);
  };

  return (
    <div style={{
      background: 'white', padding: '15px 20px', borderRadius: '12px', 
      boxShadow: '0 2px 5px rgba(0,0,0,0.05)', marginBottom: '20px',
      display: 'flex', alignItems: 'center', gap: '15px'
    }}>
      <label style={{fontWeight: '600', color: '#555'}}>Valgt Termin:</label>
      <select 
        value={selectedId} 
        onChange={handleChange}
        style={{
          padding: '8px 12px', fontSize: '1rem', border: '1px solid #ddd', 
          borderRadius: '6px', minWidth: '200px'
        }}
      >
        {terminer.map(t => (
          <option key={t.id} value={t.id}>{t.navn}</option>
        ))}
      </select>
    </div>
  );
};

export default TerminSelector;